import { action } from 'satcheljs';
import { CalendarEvent } from 'owa-calendar-types';

export const openComposeView = action('openComposeView', (event: Partial<CalendarEvent>) => ({
    event,
}));
